import { render, staticRenderFns } from "./WorkDetail7.vue?vue&type=template&id=9607c08c&scoped=true&"
import script from "./WorkDetail7.vue?vue&type=script&lang=js&"
export * from "./WorkDetail7.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetail7.vue?vue&type=style&index=0&id=9607c08c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9607c08c",
  null
  
)

export default component.exports